<form
  [formGroup]="form"
  *transloco="let fieldTranslation; read: 'field-types'"
>
  <div class="grid sm:grid-cols-4 gap-8 w-full">
    <!-- Name -->
    <div class="sm:col-span-4">
      <mat-form-field class="fuse-mat-no-subscript w-full">
        <mat-label>{{ fieldTranslation("Placeholder") }}</mat-label>
        <input
          [placeholder]="fieldTranslation('Placeholder')"
          formControlName="placeholder"
          autocomplete="off"
          matInput
        />
      </mat-form-field>
    </div>
  </div>
</form>
